<template>
  <div class="million-read-book-list-explore">
    <div v-if="!inAppWebView"
         class="million-read-book-list-explore-header-bar"
    >
      <ym-header-back-btn class="back-btn" />
      <ym-icon class="share-icon"
               name="mr-share"
               v-ym-report:MILLION_VIP_BOOK_LIST_LIST_SHARE_CLICK=""
               @click="handleShare"
      />
    </div>
    <div v-if="render.pageTitle"
         class="million-read-book-list-explore-title">
      {{ render.pageTitle }}
    </div>
    <ym-loadmore v-model="loading"
                 :finished="allLoad"
                 @load="fetchData"
    >
      <div class="million-read-book-list-explore-list">
        <book-list-explore-item v-for="(item, index) in list"
                        :key="index"
                        :item="item"
        />
      </div>
    </ym-loadmore>
    <empty-page v-if="list.length === 0"
                :hint="emptyPageHint"
                type="million-read"
    />
    <share-mask :show.sync="showShareMask"
                :share-path="$wechat.getWechatMenuShareAppLink()"
                message="请复制下方链接，前往粘贴给好友"
    />
  </div>
</template>

<script>
  import { Loadmore, HeaderBackBtn } from '@ymba/ym-ui';
  import ShareMask from '@/components/ShareMask';
  import EmptyPage from '@/components/EmptyPage';
  import BookListExploreItem from '@/pages/MillionRead/components/BookListExploreItem';
  import { getBookListExplore } from '@/services/million-read';
  import { LIMIT } from '@/utils/constant';
  import { isAppWebView } from '@/utils';

  export default {
    name: 'MillionReadBookListExplore',
    metaInfo: {},
    components: {
      'ym-loadmore': Loadmore,
      'ym-header-back-btn': HeaderBackBtn,
      ShareMask,
      BookListExploreItem,
      EmptyPage,
    },
    data() {
      return {
        showShareMask: false,
        list: [],
        start: 0,
        loading: false,
        allLoad: false,
        render: {},
      };
    },
    computed: {
      emptyPageHint() {
        return this.allLoad ? '没有相关书单哦~' : '正在加载~';
      },
      inAppWebView() {
        return isAppWebView();
      },
    },
    methods: {
      handleShare() {
        this.showShareMask = true;
      },
      async fetchData() {
        if (this.allLoad) return;
        this.loading = true;
        const data = await getBookListExplore({
          start: this.start,
          limit: LIMIT,
        });
        this.render = data.render;
        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }
        this.list = [...this.list, ...data.list];
        this.start = data.start;
        this.loading = false;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-book-list-explore {
    min-height: 100%;
    background: #f5f6fa;
    &-header-bar {
      box-sizing: border-box;
      width: 100%;
      height: 88px;
      padding: 0 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .share-icon {
        font-size: @font-size-extra-large;
      }
    }
    &-title {
      box-sizing: border-box;
      color: @color-black-dark;
      font-size: @font-size-extra-extra-large;
      font-weight: @font-weight-bold;
      line-height: 1;
      padding: 40px 32px;
    }
    &-list {
      padding: 0 32px;
    }
  }

</style>
